import type { IntlShape, MessageDescriptor } from 'react-intl';
import type { PresaveFansReleaseCounts } from 'fym-shared/src/smartlinks/presaveSubscriptions';
import { fansMessages as messages } from './fansMessages';

/**
 * The "Not saved" line of a release: the non-zero reasons in the order of design c1, joined with
 * " · ". An empty string when every fan got the song.
 */
export function fansReleaseReasons(intl: IntlShape, counts: PresaveFansReleaseCounts): string {
  const reasons: [number, MessageDescriptor][] = [
    [counts.skippedNoItem, messages.reasonNoItem],
    [counts.needsReauth, messages.reasonReauth],
    [counts.skippedCap, messages.reasonCap],
    [counts.skippedPlan, messages.reasonPlan],
    [counts.failed, messages.reasonFailed],
  ];
  return reasons
    .filter(([count]) => count > 0)
    .map(([count, message]) => intl.formatMessage(message, { count: intl.formatNumber(count) }))
    .join(' · ');
}
